import { ClientSideConfig } from 'types';

export function getFavoritesConfig(flags: any, config: ClientSideConfig) {
  const { endpoints, publicKeys } = config;

  return {
    api: endpoints.userFavoritesApi,
    emailOnlyLoginApi: endpoints.userEmailOnlyLoginApi,
    emailOnlyOtpValidateApi: endpoints.userEmailOnlyValidateApi,
    flags,
    gaClientId: publicKeys.guestAccountClientId,
    link: '/favorites',
    userMergeApi: endpoints.userMergeApi,
  };
}